export const TERMINAL_SLIP_STATUSES = ['cancelled', 'refunded'] as const

export type SlipTabFilter = 'waiting' | 'checked' | 'today' | 'all'

export type SlipTabContext = {
  status?: string
  isSettled?: boolean
  roundStatus?: string | null
}

export function normalizeSlipStatus(status: unknown): string {
  return String(status || '').toLowerCase()
}

export function isTerminalSlipStatus(status: unknown): boolean {
  const normalized = normalizeSlipStatus(status)
  return (TERMINAL_SLIP_STATUSES as readonly string[]).includes(normalized)
}

export function isRoundCancelledSlip(slip: Pick<SlipTabContext, 'roundStatus'>): boolean {
  return normalizeSlipStatus(slip.roundStatus) === 'cancelled'
}

/** Slips still waiting for win/loss (tab: รอผล). */
export function isSlipAwaitingResult(slip: SlipTabContext): boolean {
  if (isTerminalSlipStatus(slip.status)) return false
  if (isRoundCancelledSlip(slip)) return false
  return !slip.isSettled
}

/** Slips that belong in tab: ผลออกแล้ว (settled, voided, or round cancelled). */
export function isSlipInResultTab(slip: SlipTabContext): boolean {
  if (isTerminalSlipStatus(slip.status)) return true
  if (isRoundCancelledSlip(slip)) return true
  return slip.isSettled === true
}

export function filterSlipsForTab<T extends SlipTabContext>(
  slips: T[],
  filter: SlipTabFilter
): T[] {
  if (filter === 'all' || filter === 'today') return slips
  if (filter === 'waiting') return slips.filter(isSlipAwaitingResult)
  if (filter === 'checked') return slips.filter(isSlipInResultTab)
  return slips
}
